import ContactSalesNotice from '../../components/ContactSalesNotice';
import { selectProfile } from '../../../../../store/workspace/selectors';
import PriceSummary from '../../components/PriceSummary';
import { useDispatch, useSelector } from '../../../../../store/store';
import { InviteMemberIcon } from '../../../../../assets/icons';
import { ExtraServiceOption } from '../../types';
import DropDown from '../../../../../components/DropDown';
import styles from './style.module.scss';
import Modal from '../../../../../components/Modal';
import { useState } from 'react';
import {
    APPLICANT_OPTIONS,
    FALLBACK_PLAN_TYPE,
    APPLICANT_UNIT_PRICES,
} from '../../constants';
import {
    setExtraServiceDetail,
    setAddExtraApplicantModal,
    setExtraServicesPaymentModal,
} from '../../../../../store/workspace/slice';

export default function AddExtraApplicant() {
    const dispatch = useDispatch();
    const profile = useSelector(selectProfile);
    const [selectedOption, setSelectedOption] = useState<ExtraServiceOption | null>(null);
    const unitPrice = APPLICANT_UNIT_PRICES[profile?.planType || FALLBACK_PLAN_TYPE];
    const needsSales = Boolean(selectedOption?.contactSales);

    const closeModal = () => dispatch(setAddExtraApplicantModal(false));

    const submit = () => {
        if (!selectedOption) return;

        dispatch(setExtraServiceDetail({
            type: 'applicant',
            sub: selectedOption.sub,
        }));

        closeModal();
        dispatch(setExtraServicesPaymentModal(true));
    };

    return (
        <Modal
            size='md'
            actions='both'
            title='Add applicant'
            closeFunc={closeModal}
            icon={<InviteMemberIcon />}
            childClassName={styles.wrapper}
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: closeModal,
            }}
            confirmButton={{
                text: 'Continue',
                type: 'Primary',
                onClick: submit,
                disabled: !selectedOption || needsSales,
            }}
        >
            <h6>To add more, an additional applicants charge applies.</h6>

            <DropDown
                idKey='id'
                titleKey='title'
                dropDownList={APPLICANT_OPTIONS}
                selectedItem={selectedOption}
                setItem={setSelectedOption}
            />

            {!needsSales && <PriceSummary
                breakdown={`$${unitPrice} per 50 applicants`}
                total={(selectedOption?.sub || 0) * unitPrice}
            />}

            {needsSales && <ContactSalesNotice
                text='For more than 1000 applicants you should contact sales!'
            />}
        </Modal>
    );
};
